import {Component} from '@angular/core';

@Component({
  selector: 'app-impressum',
  templateUrl: './impressum.component.html',
})
export class ImpressumComponent {

}
